import employeeComplaintsEndpoints from "apis/employeeComplaints";
import { EmployeeComplaintAddRequest, EmployeeComplaintAttachmentResponse, EmployeeComplaintCategory, EmployeeComplaintResponse } from "interfaces/Mueller.Business.Models.ts";
import { WebApiRequest, HTTP_GET, HTTP_POST } from "tools/webservice";
import { Ref } from "react";

export const getEmployeeComplaints = (employeeId: number, successCallback: (complaints: EmployeeComplaintResponse[]) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => {
  return WebApiRequest(
    {
      method: HTTP_GET,
      endpoint: employeeComplaintsEndpoints.getAllComplaintsByEmployeeId(employeeId),
      successCallback,
      errorCallback,
      mountedRef
    });
};

export const getComplaintAttachment = (lookupKey: string, successCallback: (complaintAttachments: EmployeeComplaintAttachmentResponse[]) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => {
  return WebApiRequest(
    {
      method: HTTP_GET,
      endpoint: employeeComplaintsEndpoints.getComplaintAttachment(lookupKey),
      successCallback,
      errorCallback,
      mountedRef
    });
};

export const postComplaintAttachment = (payload: File, fileName: string, successCallback: (guid: string) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => {
  return WebApiRequest(
    {
      method: HTTP_POST,
      endpoint: employeeComplaintsEndpoints.postComplaintAttachment(fileName),
      payload: null,
      successCallback,
      mountedRef,
      errorCallback,
      file: payload
    });
};

export const postComplaint = (payload: EmployeeComplaintAddRequest, successCallback: () => void, errorCallback: () => void, mountedRef: Ref<boolean>) => {
  return WebApiRequest(
    {
      method: HTTP_POST,
      endpoint: employeeComplaintsEndpoints.postComplaint(),
      payload,
      successCallback,
      errorCallback,
      mountedRef
    });
};

export const getComplaintCategories = (employeeId: number, mountedRef: Ref<boolean>, successCallback: (response: EmployeeComplaintCategory[]) => void, errorCallback?: () => void) => {
  return WebApiRequest(
    {
      method: HTTP_GET,
      endpoint: employeeComplaintsEndpoints.getComplaintCategories(employeeId),
      successCallback,
      errorCallback,
      mountedRef
    });
};
